import { getValue } from '../getValue';
//用法
function loadJS(url, success) {
  var domScript = document.createElement('script');
  domScript.src = url;
  success = success || function () {};
  domScript.onload = domScript.onreadystatechange = function () {
    if (!this.readyState || 'loaded' === this.readyState || 'complete' === this.readyState) {
      success();
      this.onload = this.onreadystatechange = null;
      this.parentNode.removeChild(this);
    }
  };

  document.getElementsByTagName('body')[0].appendChild(domScript);
}

const bankFn = () => {
  const channel = getValue('channel');
  // 民生银行
  if (channel === 'kgcmbc') {
    loadJS('/cmbcForClient.js');
  }
};

export default bankFn;
